import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ShareModal from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.shareModal,
  };
}

export default withRouter(connect(mapStateToProps)(ShareModal));



// WEBPACK FOOTER //
// ./src/components/ShareModal/container/index.js